import 'core-js/stable';

window.$ = jQuery;
window.jQuery = jQuery;

require('ninelines-ua-parser');
